import WorkLogo_1 from '../../pictures/worklogo1.png';
import WorkLogo_2 from '../../pictures/worklogo2.png';
import WorkLogo_3 from '../../pictures/worklogo3.png';
import WorkLogo_4 from '../../pictures/worklogo4.png';
import WorkLogo_5 from '../../pictures/worklogo5.png';
import WorkLogo_6 from '../../pictures/worklogo6.png';
import WorkLogo_7 from '../../pictures/wogklogo7.png';

import WorkLogo_9 from '../../pictures/worklogo9.png';

import WorkLogo_10 from '../../pictures/worklogo10.png';
import WorkLogo_11 from '../../pictures/worklogo11.png';
import WorkLogo_12 from '../../pictures/worklogo12.png';
import WorkLogo_14 from '../../pictures/worklogo14.png';

import './page-oborudovanie.css';

import WorkLogo_13 from '../../pictures/worklogo13.png';
import WorkLogo_15 from '../../pictures/worklogo15.png';
import WorkLogo_16 from '../../pictures/worklogo16.png';
import WorkLogo_17 from '../../pictures/worklogo17.png';
import WorkLogo_18 from '../../pictures/worklogo18.png';
import WorkLogo_19 from '../../pictures/worklogo19.png';
import WorkLogo_20 from '../../pictures/worklogo20.png';

import Text from '../../@common.blocks/Text/index';
import ScrollToTop from '../../@common.blocks/ScrollToTop/index';
import { Link } from 'react-router-dom';

import '../../../index.css';

const PageOborudovanie = () => {
  return (
    <section className="page-oborudovanie">
      <ScrollToTop />

      <div className="page-oborudovanie__wrapper">
        <div className="page-oborudovanie__content">
          <div className="page-oborudovanie__content-img" id="equipping_TDM">
            <img src={WorkLogo_1} alt="" />
          </div>
          <Text component="p" section="equipping">
            Компания TDM ELECTRIC - лидер в комплексном производстве электро- и
            светотехники, кабельно-проводниковой продукции, тепловой техники,
            вентиляции, инструмента на территории РФ, стран СНГ и ближнего
            зарубежья. Лидер в комплексном производстве широкого спектра
            электро- и светотехнической продукции под торговой маркой TDM
            ELECTRIC – производство от сложных технических изделий до продуктов
            розничного потребления. Торговая марка TDM ELECTRIC прошла
            официальную международную регистрацию товарного знака. Качество
            продукции – одно из важнейших приоритетов компании. Выпускаемые
            изделия подлежат обязательной сертификации. Образцы продукции
            подвергаются контролю качества как на производстве, так и в
            собственной лаборатории в г. Чехове. Лаборатория оснащена новейшим
            оборудованием, позволяющим проводить весь комплекс испытаний и
            проверок на соответствие заявлен-ным параметрам и требованиям ГОСТ.
            <Link to="https://tdme.ru/">
              <Text component="a" section="equipping">
                Официальный сайт: https://tdme.ru/
              </Text>
            </Link>
          </Text>
          <div className="page-oborudovanie__content-img" id="equipping_EKF">
            <img src={WorkLogo_2} alt="" />
          </div>
          <Text component="p" section="equipping">
            Основные товарные направления компании EKF: низковольтная
            электротехническая продукция, оборудование среднего напряжения,
            корпуса электрощитов, изделия для электромонтажа и электроустановки,
            средства измерения, кабеленесущие системы, шинопровод, умный дом,
            молниезащита, профессиональное освещение. Ассортимент разработан с
            учетом отраслевой специфики и потребностей покупателей. Приоритетное
            направление работы компании – разработка комплексных
            энергоэффективных решений для промышленных предприятий,
            проектирования и строительства энергетических, гражданских и
            инфраструктурных объектов. В производственную базу компании входят
            площадки во Владимирской области. На предприятиях соблюдаются
            принципы устойчивого развития и ESG – забота об экологии, социальная
            ответственность, управление. Современные логистические комплексы
            компании расположены в Москве, Новосибирске, Екатеринбурге,
            Ростове-на-Дону, Алма-Ате и Ташкенте и позволяют осуществлять
            оперативную доставку по всей России и СНГ.
            <Link to="https://ekfgroup.com/">
              <Text component="a" section="equipping">
                Официальный сайт: https://ekfgroup.com/
              </Text>
            </Link>
          </Text>
          <div className="page-oborudovanie__content-img" id="equipping_DKC">
            <img src={WorkLogo_3} alt="" />{' '}
          </div>
          <Text component="p" section="equipping">
            АО "ДКС" (DKC) производит продукцию для организации систем
            электроснабжения, автоматизации и распределения энергии на объектах
            любого назначения. Сегодня это – один из крупнейших производителей
            электорооборудования в России и Европе. Компания участвует в
            инновационных программах и обладает широким перечнем собственных
            патентов, а ее продукция используется в энергетической, топливной,
            химической, пищевой, строительной отраслях. Система менеджмента
            качества ДКС сертифицирована на соответствие международному
            стандарту качества ISO 9001.
            <Link to="https://www.dkc.ru/ru/">
              <Text component="a" section="equipping">
                Официальный сайт:https://www.dkc.ru/ru/
              </Text>
            </Link>
          </Text>
          <div
            className="page-oborudovanie__content-img"
            id="equipping_SystemElectric"
          >
            <img src={WorkLogo_4} alt="" />
          </div>
          <Text component="p" section="equipping">
            Schneider Electric, он же System Electric - российская
            производственная компания с мировой экспертизой. Компания занимается
            разработкой и производством оборудования для распределения
            электроэнергии и промышленной автоматизации. Технические решения
            System Electric помогают внедрять инновации и улучшать
            бизнес-процессы. Комплексные решения для энергетики, промышленной
            автоматизации, IT-инфраструктуры и зданий. Продукция System Electric
            соответствует международным и российским стандартам качества, а
            комплексная сервисная поддержка помогает поддерживать оборудование в
            исправном состоянии и продлевать срок его службы. Также такие бренды
            как Механотроника, Dekraft, Systeme Soft производятся и
            разрабатываются компанией System Electric, и продолжают оказывать
            сервис базы оборудования Schneider Electric в качестве
            авторизованного поставщика сервисных услуг.
            <Link to="https://systeme.ru/">
              <Text component="a" section="equipping">
                Официальный сайт:https://systeme.ru/
              </Text>
            </Link>
          </Text>
          <div className="page-oborudovanie__content-img" id="equipping_ABB">
            <img src={WorkLogo_5} alt="" />
          </div>
          <Text component="p" section="equipping">
            ABB является технологическим лидером в области электрификации и
            автоматизации, обеспечивающим более устойчивое и ресурсосберегающее
            будущее. Решения компании объединяют инженерные ноу-хау и
            программное обеспечение для оптимизации процессов производства,
            перемещения, питания и эксплуатации оборудования. Опираясь на более
            чем 130-летний опыт работы, 105 000 сотрудников ABB стремятся
            внедрять инновации, которые ускоряют преобразования в
            промышленности.
            <Link to="https://abbrussia.ru/">
              <Text component="a" section="equipping">
                Официальный сайт:https://abbrussia.ru/
              </Text>
            </Link>
          </Text>
          <div className="page-oborudovanie__content-img" id="equipping_IEK">
            <img src={WorkLogo_6} alt="" />
          </div>
          <Text component="p" section="equipping">
            Торговая марка IEK® известна в России и СНГ уже более 15 лет. Это
            проверенный временем российский электротехнический бренд, который
            является гарантом надежности для потребителей. Полное соответствие
            заявленным техническим характеристикам определяет высокое качество
            продукции IEK®. Эта продукция обладает сочетанием основных
            характеристик успешного электротехнического бренда: долговечностью,
            оптимальной ценой, широким ассортиментом по всем группам товаров,
            лаконичным и эстетичным дизайном и простыми конструктивными
            решениями для быстрого обслуживания.
            <Link to="https://iek.spb.ru/">
              <Text component="a" section="equipping">
                Официальный сайт:https://iek.spb.ru/
              </Text>
            </Link>
          </Text>
          <div className="page-oborudovanie__content-img" id="equipping_OSTEC">
            <img src={WorkLogo_7} alt="" />
          </div>
          <Text component="p" section="equipping">
            OSTEC – отечественный изготовитель кабеленесущих систем. Опыт работы
            на электротехническом рынке РФ и стран СНГ – более чем 20 лет.
            Продукция, выпускаемая компанией дает возможность электромонтажным
            компаниям организовывать комплексные решения для различных проектов
            в строительной, энергетической, нефтегазовой отраслях и на
            промышленных объектах. Научно-исследовательские, а также
            опытно-конструкторские наработки компании позволяют выпускать
            востребованную продукцию, заменяя без потери качества аналоги
            иностранного производства. «ОСТЕК» неизменно предоставляет своим
            клиентам и партнерам своевременную маркетинговую и техническую
            поддержку. Продукция «ОСТЕК» — металлические кабельные лотки –
            позволяет проектировать кабельные магистрали в промышленном и
            гражданском строительстве, а значительный опыт и частое обновление
            каталога сделали «ОСТЕК» одним из фаворитов рынка кабеленесущих
            систем, это отличные инженерные решения для электромонтажа различной
            сложности. Лучшие инновационные решения для организации: размещения
            кабельных магистралей на ограждениях; систем освещения; кабельных
            линии в метро, а также подземных коммуникаций; сооружения
            инфраструктуры ЦОД и СКС; прокладывания огнестойких кабельных линий
            (ОКЛ); организации огнестойких проходок ОКП препятствующих
            распространению огня. Ассортимент товаров и включает более 8 000
            наименований.
            <Link to="https://lotki.ru/">
              <Text component="a" section="equipping">
                Официальный сайт:https://lotki.ru/
              </Text>
            </Link>
          </Text>
          <div
            className="page-oborudovanie__content-img"
            id="equipping_Legrand"
          >
            <img src={WorkLogo_9} alt="" />
          </div>
          <Text component="p" section="equipping">
            Legrand Россия и СНГ предлагает полный комплекс решений для
            организации электрической и информационной инфраструктур объектов
            промышленного, финансового, коммерческого и жилищного секторов.
            Являясь надежным поставщиком, чья продукция отвечает высоким
            стандартам европейского качества, компания оказывает полный спектр
            услуг технического, гарантийного и информационного сопровождения.
            Клиенты Legrand получают профессиональную поддержку команды
            специалистов в подготовке и реализации проектов различного уровня
            сложности.
            <Link to="https://legrand.ru/">
              <Text component="a" section="equipping">
                Официальный сайт:https://legrand.ru/
              </Text>
            </Link>
          </Text>
          <div
            className="page-oborudovanie__content-img"
            id="equipping_DEKraft"
          >
            <img src={WorkLogo_10} alt="" />
          </div>
          <Text component="p" section="equipping">
            DEKraft – бренд низковольтного оборудования, ориентированный на
            Россию и страны СНГ c 2007 года. Продукция бренда применяется в
            системах электроснабжения объектов коммерческой и жилой
            недвижимости, инфраструктуры и промышленности, энергетической и
            нефтегазовой отраслей. Бренд DEKraft входит в семейство брендов
            группы компаний Systeme Electric (ранее Schneider Electric в России
            и Беларуси). Благодаря глобальному опыту и современным технологиям
            оборудование DEKraft соответствует международным стандартам
            качества. Основные производственные мощности бренда расположены в
            Китае, часть ассортимента: корпуса, оболочки, розетки на DIN-рейку и
            щитовые аксессуары производятся на заводах в России. Продукция
            DEKraft отвечает актуальным потребностям рынка, имеет
            унифицированный дизайн, высокий уровень качества и доступную цену.
            Складские комплексы DEKraft расположены в Москве и Екатеринбурге.
            Бренд работает под слоганом «Защитите ваше будущее», поэтому на его
            ассортимент действует расширенная гарантия до 5 лет.
            <Link to="https://www.dek.ru/">
              <Text component="a" section="equipping">
                Официальный сайт:https://www.dek.ru/
              </Text>
            </Link>
          </Text>
          <div
            className="page-oborudovanie__content-img"
            id="equipping_PhoenixContact"
          >
            <img src={WorkLogo_11} alt="" />
          </div>
          <Text component="p" section="equipping">
            Сегодня Phoenix Contact имеет представительства более чем в 50
            странах мира и насчитывает свыше 17 600 сотрудников по всему миру. С
            2015 главой компании является Франк Штюренберг, заменивший Клауса
            Айзерта. В 2002 году Phoenix Contact открыло свое дочернее
            предприятие в России – ООО «Феникс Контакт РУС». Офис предприятия
            находится в Москве и имеет ряд филиалов в 17 городах России
            (Санкт-Петербург, Воронеж, Самара, Нижний Новгород, Чебоксары,
            Казань, Волгоград, Уфа, Екатеринбург, Пермь, Тюмень, Новосибирск,
            Иркутск, Красноярск, Хабаровск, Краснодар, Челябинск).В 2017 году
            было открыто производство в России. Номенклатура выпускаемых в
            России изделий включает в себя устройства защиты от импульсных
            перенапряжений, промышленные реле, компьютеры, электротехнические
            клеммы и источники питания серии КВНТ.В 2018 году было подписано
            партнерское соглашение в области энергоэффективности между ООО
            «Феникс Контакт РУС» и Фондом «Сколково». В рамках партнерского
            соглашения в Инновационном центре «Сколково» будет построено
            офисно-административное здание и складской комплекс «Феникс Контакт»
            в России, а также Региональный центр разработок и отраслевых
            компетенций для всего Евразийского региона.В конце мая 2022 года
            руководством концерна Phoenix Contact GmbH & Co. KG было принято
            решение о передаче двух дочерних компаний организации — «Феникс
            Контакт РУС» и НПО «Феникс Контакт» в собственность российского
            инвестиционного холдинга «Группа компаний Авалон», который в
            настоящий момент ведёт работу в следующих направлениях: •
            производство электротехнического и светотехнического оборудования; •
            системы накопления энергии; • светотехнический инжиниринг; •
            девелопмент коммерческой недвижимости. После завершения всех
            сопутствующих переходу процедур «Феникс Контакт РУС» будет
            переименовано в НПО «АвалонЭлектроТех». Завод в г. Ступино также
            продолжит дальнейшую работу, но теперь уже под названием «Ступинский
            электротехнический завод». Главным вектором производства станет
            разработка комплексных решений и поставки электротехнических
            изделий. При этом предприятие продолжит сотрудничество с российскими
            заказчиками электротехнического оборудования. Предприятие также
            сейчас производит пружинные клеммы только уже под отечественным
            брендом СТЭЗ.
            <Link
              to="https://www.феникс-контакт.рус/
            https://www.avalonelectrotech.ru/"
            >
              <Text component="a" section="equipping">
                Официальный сайт:https://www.феникс-контакт.рус/ ;
                https://www.avalonelectrotech.ru/
              </Text>
            </Link>
          </Text>
          <div className="page-oborudovanie__content-img" id="equipping_КЭАЗ">
            <img src={WorkLogo_12} alt="" />
          </div>
          <Text component="p" section="equipping">
            КЭАЗ - непрерывно развивающаяся компания, выпускающая новые
            продукты, внедряя передовые технологии, расширяя производственные
            площади, приобретая современное оборудование. Сегодня на площади 60
            000 кв.м. работают 1900 станков, позволяя производить более 28 000
            наименований надежных электротехнических продуктов в России и для
            России. Система менеджмента качества завода соответствует
            требованиям международных и отечественных стандартов ИСО 9001:2015,
            ГОСТ Р ИСО 9001-2015 и ГОСТ РВ 0015-002-2012 (в системе
            «Оборонсертифика»). НАДЕЖНОСТЬ БЕЗ КОМПРОМИССОВ - главное качество
            продукции КЭАЗ. Именно ее ценят клиенты и партнеры компании:
            аппараты КЭАЗ защищают энергосистемы объектов МО, промышленных
            гигантов, морских судов, ТЭЦ, АЭС, МРСК, кораблей и подводных лодок
            ВМФ РФ, подвижных составов РЖД и метрополитена.
            <Link to="https://keaz.ru/">
              <Text component="a" section="equipping">
                Официальный сайт: https://keaz.ru/
              </Text>
            </Link>
          </Text>
          <div
            className="page-oborudovanie__content-img"
            id="equipping_WEIDMULLER"
          >
            <img src={WorkLogo_14} alt="" />
          </div>
          <Text component="p" section="equipping">
            Weidmüller — немецкий бренд продуктов и сервисных решений в области
            промышленных соединений, обмена сигналами и данными.Производитель
            бренда — компания Weidmüller — был основан в Германии в 1850.
            Технологии электронных и электрических соединений Weidmüller широко
            известны на современном рынке и распространены в 80-ти
            странах.Продуктовая линейка включает в себя преимущественно изделия
            для распределительных шкафов и электроразводки вне корпуса: клеммы и
            клеммные колодки для соединения проводов, соединительные компоненты
            для печатных плат и промышленных сетей, аппаратуру электропитания,
            устройства защиты от перенапряжений, элементы систем ввода-вывода и
            прочие.
            <Link to="https://www.weidmuller.com/">
              <Text component="a" section="equipping">
                Официальный сайт:https://www.weidmuller.com/
              </Text>
            </Link>
          </Text>
          <div
            className="page-oborudovanie__content-img"
            id="kontrollery_SIEMENS"
          >
            <img src={WorkLogo_13} alt="" />
          </div>
          <Text component="p" section="equipping">
            Промышленные контроллеры Siemens используются в самых разных
            отраслях промышленности. Особенно широкое распространение получили
            модели Simatic S7-300, S7-400 и S7-1200, что объясняется их высоким
            качеством и надежностью. Программируемые логические контроллеры
            Siemens имеют ряд технологических преимуществ перед конкурентами:
            многофункциональность; возможность создания систем автоматизации
            различной сложности, возможность эксплуатации ПЛК в сложных
            условиях; практически полная автономность; простота в обслуживании.
            Контроллеры Siemens — это эффективное решение для создания
            автоматизации!
            <Link to="https://ru-siemens.com/">
              <Text component="a" section="equipping">
                Официальный сайт:https://ru-siemens.com/
              </Text>
            </Link>
          </Text>
          <div
            className="page-oborudovanie__content-img"
            id="kontrollery_UNITRINICS"
          >
            <img src={WorkLogo_15} alt="" />
          </div>
          <Text component="p" section="equipping">
            Unitronics разрабатывает, производит и продвигает передовые решения
            для управления и автоматизации. Мы предлагаем широкий модельный ряд
            PLC, PLC со встроенным HMI, полную линейку преобразователей частоты
            (ПЧ), весь спектр модулейввода/вывода и вспомогательного
            оборудования, а также программное обеспечение для программирования
            .Unitronics предлагает решения начиная от микро-PLC + HMI для
            управления простым оборудованием до высокопроизводительных
            многофункциональных контроллеров с богатым ассортиментом встроенных
            и удаленных модулейввода/вывода и различными вариантами
            коммуникаций, в том числе с поддержкой стратегии «Индустрия 4.0»
            <Link to="https://www.unitronics.ru/">
              <Text component="a" section="equipping">
                Официальный сайт:https://www.unitronics.ru/
              </Text>
            </Link>
          </Text>
          <div className="page-oborudovanie__content-img" id="kontrollery_ONI">
            <img src={WorkLogo_16} alt="" />
          </div>
          <Text component="p" section="equipping">
            Продукция ONI выпускается на контрактных зарубежных производственных
            площадках — мировых лидерах по производству оборудования для
            промышленной автоматизации, одна из ключевых расположена в Южной
            Корее. Команда сотрудников ONI обладает солидным опытом работы в
            ведущих международных компаниях по производству электроники.
            Благодаря этому они смогли реализовать все самые современные и
            передовые технологии в процессе разработки и создания оборудования
            ONI.Все оборудование ONI проходит многоступенчатый контроль качества
            и тестирование на эксплуатацию в рабочих условиях в собственном
            испытательном центре. На продукцию ONI предоставляется долгосрочная
            гарантия, техническая поддержка и, при необходимости, качественное
            сервисное обслуживание.
            <Link to="https://oni-system.com/">
              <Text component="a" section="equipping">
                Официальный сайт:https://oni-system.com/
              </Text>
            </Link>
          </Text>
          <div
            className="page-oborudovanie__content-img"
            id="kontrollery_HELMHOLZ"
          >
            <img src={WorkLogo_17} alt="" />
          </div>
          <Text component="p" section="equipping">
            Helmholz — ваш специалист, когда дело касается сложных продуктов для
            ваших проектов автоматизации. Благодаря современным умным системным
            решениям от Helmholz высокие требования, предъявляемые к
            промышленным сетям в эпоху растущей автоматизации, могут быть
            выполнены как надежно, так и эффективно, включая высокий уровень
            удобства эксплуатации. Широкий спектр продукции варьируется от
            децентрализованной системы ввода-вывода до коммутаторов и
            повторителей, шлюзов, шлюза NAT/брандмауэра и безопасного удаленного
            доступа к машинам IoT.Компания Helmholz стремится предложить
            идеальное решение для любой задачи автоматизации: с помощью
            ориентированных на рынок, интеллектуальных продуктов и простой,
            быстрой и эффективной поддержки.
            <Link to="https://www.helmholz.de/">
              <Text component="a" section="equipping">
                Официальный сайт:https://www.helmholz.de/
              </Text>
            </Link>
          </Text>
          <div className="page-oborudovanie__content-img" id="kontrollery_OBEH">
            <img src={WorkLogo_18} alt="" />
          </div>
          <Text component="p" section="equipping">
            Ведущий российский разработчик и производитель
            контрольно-измерительных приборов и средств промышленной
            автоматизации. ОВЕН работает с 1991 года. За 25 лет тысячи
            предприятий автоматизировали свои технологические процессы,
            используя автоматику ОВЕН. С помощью оборудования ОВЕН можно
            создавать системы управления и диспетчеризации с применением
            проводных и беспроводных технологий связи.
            <Link to="https://owen.ru/">
              <Text component="a" section="equipping">
                Официальный сайт:https://owen.ru/
              </Text>
            </Link>
          </Text>
          <div className="page-oborudovanie__content-img" id="kontrollery_GCAN">
            <img src={WorkLogo_19} alt="" />
          </div>
          <Text component="p" section="equipping">
            Контроллеры GCAN производит компания Shenyang Vhandy Technology Co.,
            Ltd. Компания находится в Шэньяне, промышленном центре на
            северо-востоке Китая. Это высокотехнологичное предприятие на базе
            Шэньянского технологического университета.Компания предоставляет
            клиентам такие продукты, как модули полевых шин и промышленные
            контроллеры и уже давно занимается разработкой и обслуживанием
            продуктов в области промышленной связи и промышленного управления.
            Компания имеет многолетний опыт работы в отрасли.
            <Link to="  https://www.plcsystems.ru/vendors/gcan/">
              <Text component="a" section="equipping">
                Официальный сайт:https://www.plcsystems.ru/vendors/gcan/
              </Text>
            </Link>
          </Text>
          <div
            className="page-oborudovanie__content-img"
            id="kontrollery_SEGNETICS"
          >
            <img src={WorkLogo_20} alt="" />
          </div>
          <Text component="p" section="equipping">
            Это российская компания, основанная в 2003 году. Основная
            деятельность компании – это разработка и производство
            программируемых логических контроллеров, но кроме этого
            разрабатываются и программное обеспечение, и инновационные
            технологии передачи данных. Рассмотрим каждый из аспектов
            подробнее.Руководствуясь принципами обеспечения наивысшего качества,
            Segnetics стремится полностью контролировать процесс производства
            своих устройств. При высоком уровне качества в изделия постоянно
            добавляются новые технологии, а линейка оборудования
            расширяется.Переход компании на новый уровень производства
            высокотехнологичных изделий произошел в 2014 году, когда была
            запущена в эксплуатацию полностью автоматизированная линия
            поверхностного монтажа SMD.Полная автоматизация линии позволяет
            исключить человеческий фактор при сборке приборов, а также
            значительно увеличить скорость производства.
            <Link to="https://segnetics.com/">
              <Text component="a" section="equipping">
                Официальный сайт:https://segnetics.com/
              </Text>
            </Link>
          </Text>
        </div>
      </div>
    </section>
  );
};
export default PageOborudovanie;
